import { isArray } from 'lodash';
import { getArrayRem } from './getArrayRem';
import { getRem } from './getRem';
export function getValue(value, unit) {
  if (unit === 'rem') {
    if (isArray(value)) {
      return getArrayRem(value);
    }

    return getRem(value);
  }

  return value;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9nZXRWYWx1ZS50cyJdLCJuYW1lcyI6WyJpc0FycmF5IiwiZ2V0QXJyYXlSZW0iLCJnZXRSZW0iLCJnZXRWYWx1ZSIsInZhbHVlIiwidW5pdCJdLCJtYXBwaW5ncyI6IkFBQUEsU0FBU0EsT0FBVCxRQUF3QixRQUF4QjtBQUVBLFNBQVNDLFdBQVQsUUFBNEIsZUFBNUI7QUFDQSxTQUFTQyxNQUFULFFBQXVCLFVBQXZCO0FBRUEsT0FBTyxTQUFTQyxRQUFULENBQWtCQyxLQUFsQixFQUFtREMsSUFBbkQsRUFBaUU7QUFDdEUsTUFBSUEsSUFBSSxLQUFLLEtBQWIsRUFBb0I7QUFDbEIsUUFBSUwsT0FBTyxDQUFDSSxLQUFELENBQVgsRUFBb0I7QUFDbEIsYUFBT0gsV0FBVyxDQUFDRyxLQUFELENBQWxCO0FBQ0Q7O0FBRUQsV0FBT0YsTUFBTSxDQUFDRSxLQUFELENBQWI7QUFDRDs7QUFFRCxTQUFPQSxLQUFQO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBpc0FycmF5IH0gZnJvbSAnbG9kYXNoJztcbmltcG9ydCB7IFVuaXRWYWx1ZSB9IGZyb20gJy4uL3R5cGVzJztcbmltcG9ydCB7IGdldEFycmF5UmVtIH0gZnJvbSAnLi9nZXRBcnJheVJlbSc7XG5pbXBvcnQgeyBnZXRSZW0gfSBmcm9tICcuL2dldFJlbSc7XG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRWYWx1ZSh2YWx1ZT86IFVuaXRWYWx1ZSB8IFVuaXRWYWx1ZVtdLCB1bml0PzogJ3JlbScpIHtcbiAgaWYgKHVuaXQgPT09ICdyZW0nKSB7XG4gICAgaWYgKGlzQXJyYXkodmFsdWUpKSB7XG4gICAgICByZXR1cm4gZ2V0QXJyYXlSZW0odmFsdWUpO1xuICAgIH1cblxuICAgIHJldHVybiBnZXRSZW0odmFsdWUpO1xuICB9XG5cbiAgcmV0dXJuIHZhbHVlO1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/utils/getValue.js
// module id = 802
// module chunks = 118